module.exports = __webpack_public_path__ + "static/media/03-08.d8b0c867.png";